import React from "react";

const Draws = () => {
    return <div>Draws</div>;
};

export default Draws;
